<template>
	<div class="default-panel" id="proList">
		<addressBar
			:isBack = 'true'
			:navBtnShow = 'true'
			:goBackLink = "this.$route.fullPath"
			v-on:navShowClick = 'navShowHandle'
			class="fixed"

		></addressBar>
			<div class="proList-panel" :style="{ height: wrapperHeight + 'px' }" ref="wrapper">
  				<mt-loadmore 
	  				:bottom-method="bottomTop" 
	  				@bottom-status-change="handleBottomChange" 
	  				:bottom-all-loaded="allLoaded"
	  				:autoFill = "false"
                	ref = "loadmore"
  				>

				  	<div class="pro-group first">
						<div class="pro-item" v-for="item in proList">
							<router-link :to="{ path: '/productdetail/'+item.goodsChannelId, query: { url: router }}">
								<img v-lazy="item.imgUrl+ '?imageView2/0/w/450'" alt="" v-if="!!item.imgUrl">
								<img src="../../../assets/images/default-pro-small.png" alt="" v-else>
								<div class="pro-details">
									<span class="title">{{item.displayName}}</span>
									<span class="price">¥{{item.discountPrice | filterPrice}}</span>
								</div>
							</router-link>
						</div>
					</div>
					<div slot="bottom" class="mint-loadmore-bottom">
		                <span v-show="bottomStatus !== 'loading'" :class="{ 'rotate': bottomStatus === 'pull' }">上拉加载更多</span>
		              	<span v-show="bottomStatus === 'loading'">Loading...</span>
		            </div>
				</mt-loadmore>
			</div>	
		<mt-popup
			v-model="navShow"
			position = 'right'
			class = 'right-nav-wap'
		>	
			
			<span class="icon-nav-group">
				<span class="icon-nav" @click="navShowHandle"></span>
			</span>
			
			 <rightNavList @change="changeList"></rightNavList>
		</mt-popup>

	</div>
</template>
<script>
	import Vue from 'vue';
	import { Popup } from '@/js/mint-ui';
	Vue.component(Popup.name, Popup);

	import { Loadmore } from '@/js/mint-ui';
	Vue.component(Loadmore.name, Loadmore);

	
	import { mapState } from 'vuex'
	import addressBar from '@/components/common/navbar/adressBar'
	import rightNavList from '@/components/home/home/classifyNavList'

	// 注册
	Vue.filter('filterPrice', function (value) {
	 	return (value/100).toFixed(2);
	})
	
	export default {
		data(){
			return {
				navShow: false,
				bottomStatus: '',
        		allLoaded: false,
        		wrapperHeight: '600'
			}
		},
		computed: {
			router(){
				return this.$route.path;
			},
			...mapState({
				classifyNav: state => state.homeState.classifyNav,
				proList: state => state.homeState.classifyProList,
				// navsShow: state => state.homeState.navShow,
				pageNo: state => state.homeState.classifyPage,
				totalPage: state => state.homeState.classifyTotalPage,

			})
		},
		watch:{
			pageNo(val){
				this.allLoaded = false;
				if(val  >= this.totalPage) {
					this.allLoaded =  true; 
				}else{
					this.allLoaded =  false; 
				}
			},
			router(val,oldVal){
				this.getProList();
			},
		},
		components: {
			addressBar,
			rightNavList
		},
		created(){
			
		},
		methods: {
			navShowHandle() {
				// this.$store.dispatch('navShowToggle');
				this.navShow = !this.navShow;
			},
	      	changeList ( id,isParent ) {
				let _id = ''
		        let _parentId = ''

		        if ( isParent === true) {
		          _parentId = id
		        } else {
		          _id = id
		        }

		        this.$store.dispatch('getClassifyProList',{
		          categoryId: _id,
		          fristCategoryId: _parentId
		        }).then(function(){

		        });

		        this.navShowHandle();

	      },
			getProList(){
				var self = this;
				let id = this.$route.params.id ? this.$route.params.id  : '';
				let parentId = this.$route.params.parentId ? this.$route.params.parentId  : '';

				self.$store.dispatch('getClassifyProList',{
					categoryId: id,
					fristCategoryId: parentId
				}).then(function(){
					if(self.pageNo > 1) return false;
					self.$nextTick(function(){
						console.log(12);
						self.wrapperHeight = document.documentElement.clientHeight - self.$refs.wrapper.getBoundingClientRect().top;
					})

				});
			},
			bottomTop() {
				this.getProList();
		        this.$refs.loadmore.onBottomLoaded();
		    },
	        handleBottomChange(status) {
	            this.bottomStatus = status;
	        }
		},
		mounted(){
			let self = this;
			self.getProList();
		},
		destroyed(){
			this.$store.dispatch('getCategory');
		}
	}
</script>

<style lang="scss">
	@import '../../../assets/css/mixin';


	.proList-panel {
		padding: pxToRem(100px) pxToRem(55px) 0 pxToRem(55px);
		.pro-group {
			padding: 0;
		}
	}

	.page-infinite-listitem {
	    height: 150px;
	    line-height: 150px;
	}
</style>


// WEBPACK FOOTER //
// productList.vue?4e047b98